module.exports = __webpack_public_path__ + "static/media/dispatch.f5e210e8.png";